import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'

Vue.use(ElementUI)
Vue.config.productionTip = false

if (localStorage.getItem('admin_token') === 'local-admin-token') localStorage.removeItem('admin_token')

new Vue({ router, render: h => h(App) }).$mount('#app')
